
import $axios from '@/plugins/axiosInstance'

// import axios from 'axios';

// axios.defaults.withCredentials = true;

export default {
 
    
              listTaslaks(formId) {
      return $axios.get('Taslak/listTaslaks/'+formId);
    },
          insert(taslak) {
      return $axios.post('Taslak',taslak);
    },
     update(id,value) {
  
      return $axios.put('Taslak/'+id,value);
    },
      delete(id) {
  
      return $axios.delete('Taslak/'+id);
    },
      

 
  };